import { useQuery } from "@tanstack/react-query";
import { fetchRecourses } from "../../../lib/api/resources/recourse";
import { recoursesColumns } from "./data/recoursesColumns";
import { Table } from "@/components/v2";

export const ClaimRecoursesList = () => {
  const recoursesQuery = useQuery({
    queryKey: ["recourses"],
    queryFn: fetchRecourses,
  });

  return (
    <Table
      dataSource={recoursesQuery.data?.member}
      columns={recoursesColumns}
      loading={recoursesQuery.isLoading}
    />
  );
};
